// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5bda9abd","977":"20d13043"}[chunkId] + ".chunk.js";
};